import * as React from "react";
import Stack from "@mui/material/Stack";

import CustomMenuItem from "./CustomMenuItem";
import { getNavbarPages } from "../../common/NavbarPages";
import { useSelector } from "react-redux";

/**
 * View : [mobile, desktop]
 * @param {direction,view} param0
 * @returns
 */
const MenuListComposition = ({ View }) => {
  const inTempView = View?.toLowerCase();
  const user = useSelector((state) => state.user);
  const [pages, setPages] = React.useState([]);

  // Load pages from API when component mounts
  React.useEffect(() => {
    const loadPages = async () => {
      try {
        const navbarPages = await getNavbarPages();
        setPages(navbarPages);
      } catch (error) {
        console.error("Failed to load navbar pages:", error);
        setPages([]); // fallback to empty array
      }
    };
    
    loadPages();
  }, []);

  return (
    <Stack direction={inTempView === "mobile" ? "column" : "row"} spacing={0}>
      {pages.map((page, index) => {
        return (
          <CustomMenuItem
            key={`CustomMenuItemJTCDashb_${index + 1}_${page.title}`} // + user.token
            MenuTitle={page.title}
            MenuTo={page.to}
            MenuAppClaims={page.appRequiredClaim}
            isOpenNewTab={page.isOpenNewTab || false}
            SubMenu={page.subMenu}
            usePopper={inTempView !== "mobile"}
          />
        );
      })}
    </Stack>
  );
};

MenuListComposition.defaultProps = {
  View: "desktop",
};

export default MenuListComposition;
